import React, { useState, useEffect } from "react";

const MiddleSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Función para verificar el tamaño de la ventana
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768); // Cambiar a 'true' si el ancho es menor o igual a 768px
    };

    // Verificar tamaño inicial
    checkScreenSize();

    // Agregar event listener para detectar cambios
    window.addEventListener("resize", checkScreenSize);

    // Limpiar el event listener al desmontar el componente
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black",
        padding: "20px 0",
      }}
    >
      <img
        src={isMobile ? "https://celebratufiesta.com.co/wp-content/uploads/2025/01/midlemediano.png" : "https://celebratufiesta.com.co/wp-content/uploads/2025/01/Recurso-7.png"}
        alt="Descripción"
        style={{
          maxWidth: "100%",
          height: "auto",
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default MiddleSection;
